require('dotenv').config(); // Load environment variables from .env file

// Access your environment variables
export const PISC_URL = process.env.REACT_APP_PISC_URL;
export const SETTING_URL = process.env.REACT_APP_SETTING_URL;
export const USERS_URL = process.env.REACT_APP_USERS_URL;
export const BOARD_URL = process.env.REACT_APP_BOARD_URL;
export const FARS_URL = process.env.REACT_APP_FARS_URL;
export const GovESB_URL = process.env.REACT_APP_GOVESB_URL;
export const REPORT_URL = process.env.REACT_APP_REPORT_URL;
export const PISC_SHARE_URL = process.env.REACT_APP_PISC_SHARE_URL;
export const NTR_URL = process.env.REACT_APP_NTR_URL;
